import { useMemo, useState } from 'react';
import { usePathname } from 'next/navigation';

//* Helpers
import { getParamsByKey } from '@/helpers/_functions';

//* Components
import Text from '@/components/common/Text';
import Icon from '@/components/common/Icon';
import CustomLink from '@/components/common/CustomLink';

//* Style
import MobileFilterItemStyle from './style';

const MobileFilterItem = ({ url, title, items, filterType, filterKey, searchParams, onFilterChange, multiple = false, isLast = false }) => {
	//! Pathname
	const pathname = usePathname();

	//! States
	const [isActive, setIsActive] = useState(false);

	//! Active Item
	const selectedValue = useMemo(() => {
		const activeItems = getParamsByKey(searchParams, filterKey);
		return !multiple ? activeItems?.[0] : activeItems;
	}, [searchParams, filterKey]);

	//! Filters
	const storeFilters = useMemo(() => {
		return items.map((item, index) => {
			return filterType == 'url' ? (
				<CustomLink
					key={index}
					url={item.url}
					className={`inner-content-item link ${pathname.includes(item.url) ? 'active' : ''}`}>
					<Text className={'h2 font-futura-regular'}>{item.name}</Text>
				</CustomLink>
			) : (
				<Text
					key={index}
					onClick={() => onFilterChange(filterKey, item.id, multiple)}
					className={`h2 font-futura-regular inner-content-item link ${(multiple ? selectedValue?.includes(`${item.id}`) : selectedValue == item.id || (filterKey == 'price' && item.id.split(',')[0] == selectedValue)) ? 'active' : ''}`}>
					{item.name}
				</Text>
			);
		});
	}, [items, selectedValue, pathname]);

	return (
		<MobileFilterItemStyle className={`${isLast ? 'last' : ''}`}>
			<div
				className='title-wrap cursor-pointer'
				onClick={() => setIsActive(!isActive)}>
				<Text className={'h2 font-futura-medium'}>{title}</Text>

				{items.length > 0 ? (
					<Icon
						name={'arrow'}
						className={`p ${isActive ? 'rotate' : ''}`}
					/>
				) : null}
			</div>

			{isActive ? <div className={`items-wrap ${isActive ? 'active' : ''}`}>{storeFilters}</div> : null}
		</MobileFilterItemStyle>
	);
};

export default MobileFilterItem;
